var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamsk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_2084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8258 0.198242L16.0002 7.94585L17.9685 3.39313L26.8258 0.198242Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97632 0.198242L12.6379 8.02572L10.7516 3.39313L1.97632 0.198242Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9713 18.249L20.1008 22.4822L26.2517 24.1596L27.974 18.3289L22.9713 18.249Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 18.3289L2.55038 24.1596L8.70128 22.4822L5.83086 18.249L0.828125 18.3289Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37313 10.9808L6.65088 13.4568L12.7198 13.6964L12.5557 7.30664L8.37313 10.9808Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4289 10.9808L16.1643 7.30664L16.0002 13.7763L22.0691 13.5367L20.4289 10.9808Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70117 22.4825L12.3917 20.7253L9.19324 18.3291L8.70117 22.4825Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4104 20.7253L20.1009 22.4825L19.6089 18.3291L16.4104 20.7253Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1009 22.4823L16.4104 20.7251L16.7384 23.0414V23.9999L20.1009 22.4823Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70117 22.4825L12.1457 24.0799V23.1215L12.4737 20.8052L8.70117 22.4825Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1458 16.8117L9.11133 15.9331L11.2436 14.9746L12.1458 16.8117Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5745 16.8117L17.4766 14.9746L19.6089 15.9331L16.5745 16.8117Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70123 22.4823L9.1933 18.249L5.83081 18.3289L8.70123 22.4823Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5269 18.249L20.0189 22.4823L22.8893 18.3289L19.5269 18.249Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1512 13.5366L16.0823 13.7762L16.6564 16.8114L17.5585 14.9743L19.6908 15.9328L22.1512 13.5366Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11124 15.9328L11.2436 14.9743L12.1457 16.8114L12.7198 13.7762L6.65088 13.5366L9.11124 15.9328Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65088 13.5366L9.19325 18.4088L9.11124 16.0127L6.65088 13.5366Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6909 15.9331L19.6089 18.3292L22.1513 13.457L19.6909 15.9331Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7198 13.7764L12.1458 16.8115L12.8839 20.4058L13.0479 15.6933L12.7198 13.7764Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 13.7764L15.6721 15.6933L15.8361 20.4058L16.5743 16.8115L16.0002 13.7764Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5743 16.8112L15.8362 20.4055L16.3283 20.7249L19.5267 18.3288L19.6087 15.9326L16.5743 16.8112Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11133 15.9326L9.19334 18.3288L12.3918 20.7249L12.8839 20.4055L12.1458 16.8112L9.11133 15.9326Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6563 24.0799V23.1214L16.4103 22.8818H12.3097L12.0637 23.1214V24.0799L8.70117 22.4824L9.93135 23.4409L12.3097 25.0383H16.4923L18.9527 23.4409L20.1008 22.4824L16.6563 24.0799Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4104 20.7253L15.9183 20.4058H12.8838L12.3918 20.7253L12.0637 23.0415L12.3098 22.8019H16.4104L16.6564 23.0415L16.4104 20.7253Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.236 8.50495L28.1381 4.19185L26.7439 0.198242L16.4104 7.70623L20.429 10.981L26.0878 12.5784L27.318 11.1407L26.7439 10.8212L27.646 10.0225L26.99 9.54329L27.8921 8.90431L27.236 8.50495Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.582031 4.19185L1.48416 8.50495L0.910079 8.90431L1.81221 9.54329L1.15612 10.0225L2.05825 10.8212L1.48416 11.2206L2.71434 12.6583L8.37317 11.0609L12.3918 7.7861L1.97624 0.198242L0.582031 4.19185Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0878 12.5784L20.429 10.981L22.1513 13.457L19.6089 18.3292L22.9714 18.2493H27.9741L26.0878 12.5784Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37323 10.981L2.7144 12.5784L0.828125 18.2493H5.83086L9.19335 18.3292L6.65098 13.457L8.37323 10.981Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 13.7765L16.3283 7.70617L17.9685 3.39307H10.6694L12.3097 7.70617L12.6377 13.7765L12.8017 15.6934V20.4058H15.8362V15.6934L16.0002 13.7765Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_2084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 25,
    fill: "white",
    transform: "translate(0.5 0.118164)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamsk);
export default __webpack_public_path__ + "static/media/metamsk.01c9d5ac03be9319eac6456d761023b0.svg";
export { ForwardRef as ReactComponent };